var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("pga-currency-field", {
                attrs: {
                  label: "Total Costs Presale",
                  dense: "",
                  readonly: "",
                },
                model: {
                  value: _vm.totalCostsPresale,
                  callback: function ($$v) {
                    _vm.totalCostsPresale = $$v
                  },
                  expression: "totalCostsPresale",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }